import React, { useState } from 'react';
import TokenSearch from './TokenSearch';
import TokenManagementPanel from './TokenManagementPanel';
import TokenAnalytics from './TokenAnalytics';
import styles from './token.module.scss';

const TokenMain = ({ isAuthenticated }) => {
  const [activeTab, setActiveTab] = useState('search');

  const tabs = [
    {
      id: 'search',
      label: '🔍 टोकन खोज',
      component: <TokenSearch />,
      public: true
    },
    {
      id: 'management',
      label: '🔑 पहुँच व्यवस्थापन',
      component: <TokenManagementPanel />,
      public: false
    },
    {
      id: 'analytics',
      label: '📊 विश्लेषण',
      component: <TokenAnalytics />,
      public: false
    }
  ];

  const availableTabs = tabs.filter(tab => tab.public || isAuthenticated);

  return (
    <div className={styles.tokenMainContainer}>
      <div className={styles.tokenHeader}>
        <h1>🔐 टोकन व्यवस्थापन प्रणाली</h1>
        <p>सुरक्षित र सजिलो डाटा पहुँचको लागि टोकन प्रणाली</p>
      </div>

      {/* Navigation Tabs */}
      <div className={styles.tabNavigation}>
        {availableTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`${styles.tabButton} ${activeTab === tab.id ? styles.activeTab : ''}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className={styles.tabContent}>
        {availableTabs.find(tab => tab.id === activeTab)?.component}
      </div>

      {/* Information Section */}
      <div className={styles.infoSection}>
        <div className={styles.infoCard}>
          <h3>💡 टोकन प्रणाली कसरी काम गर्छ?</h3>
          <ol>
            <li><strong>डाटा सेभ गर्दा:</strong> स्वचालित रूपमा अनूठो टोकन सिर्जना हुन्छ</li>
            <li><strong>टोकन प्रयोग:</strong> डाटा हेर्न र सम्पादन गर्न टोकन प्रयोग गर्नुहोस्</li>
            <li><strong>पहुँच नियन्त्रण:</strong> प्रशासकले पहुँच स्तर निर्धारण गर्न सक्छन्</li>
            <li><strong>सुरक्षा:</strong> सबै खोजहरू लग गरिन्छ र निगरानी गरिन्छ</li>
          </ol>
        </div>

        <div className={styles.infoCard}>
          <h3>🔒 सुरक्षा सुविधाहरू</h3>
          <ul>
            <li>अनूठो टोकन फरमेट (2 अक्षर + 6 अंक)</li>
            <li>पहुँच म्याद सेट गर्न सकिन्छ</li>
            <li>IP ठेगाना र युजर एजेन्ट लग</li>
            <li>पहुँच स्तर नियन्त्रण (हेर्ने, सम्पादन, प्रशासक)</li>
            <li>सबै कार्यहरूको विस्तृत लग</li>
          </ul>
        </div>

        <div className={styles.infoCard}>
          <h3>📱 प्रयोग गर्ने तरिका</h3>
          <div className={styles.usageSteps}>
            <div className={styles.step}>
              <span className={styles.stepNumber}>1</span>
              <p>आफ्नो डाटा सेभ गर्नुहोस् र टोकन प्राप्त गर्नुहोस्</p>
            </div>
            <div className={styles.step}>
              <span className={styles.stepNumber}>2</span>
              <p>टोकनलाई सुरक्षित राख्नुहोस्</p>
            </div>
            <div className={styles.step}>
              <span className={styles.stepNumber}>3</span>
              <p>डाटा हेर्न र सम्पादन गर्न टोकन प्रयोग गर्नुहोस्</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className={styles.tokenFooter}>
        <p>🔐 टोकन प्रणाली - सुरक्षित र सजिलो डाटा पहुँच</p>
        <p>सम्पर्क: प्रशासकलाई सम्पर्क गर्नुहोस् यदि टोकन काम गर्दैन भने</p>
      </div>
    </div>
  );
};

export default TokenMain;
